import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { AppConstants } from "src/utils/app.constants";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorage } from "src/utils/local-storage";
import { environment } from "src/environments/environment";
import { PracticeResourceResponse } from "./hub/practice-resources.interface";
import { ContinuingEducationResponse } from "./hub/continuing-education.interface";
import { EventsResponse } from "./hub/events.interface";

@Injectable()
export class HubService {
    
    constructor(private httpClient: HttpClient) {

    }

    public changeLang(translationService: TranslateService, currentLanguage: string, localStorage: LocalStorage): string {

        console.log(currentLanguage);
        const newLang = currentLanguage === AppConstants.ENGLISH_CODE ? AppConstants.FRENCH_CODE : AppConstants.ENGLISH_CODE;
        localStorage.setPreferredLang(newLang);

        translationService.use(newLang);

        return this.getLanguageText(newLang);
    }

    public setLang(translationService: TranslateService, currentLanguage: string, 
        localStorage: LocalStorage): string {
        translationService.use(currentLanguage === AppConstants.ENGLISH_CODE
        ? AppConstants.ENGLISH_CODE : AppConstants.FRENCH_CODE);

        currentLanguage = translationService.currentLang;
        localStorage.setPreferredLang(currentLanguage);

        return this.getLanguageText(currentLanguage);
    }

    getLanguageText(currentLanguage: string) : string {
        return currentLanguage === AppConstants.ENGLISH_CODE
        ? AppConstants.FRENCH_CODE.toUpperCase() : AppConstants.ENGLISH_CODE.toUpperCase();
    }

    getAdData(): Observable<any> {
        return this.httpClient.get('assets/test/ad.json', { responseType: 'json' });
    }

    getAbsorbAuthToken(): Observable<any> {
        return this.httpClient.get(environment.COMMONS_API_ENDPOINT + '/hub/absorb', {responseType: 'text'});
    }

    getShortages(currentLang: string): Observable<any> {
        return this.httpClient.get(environment.COMMONS_API_ENDPOINT + '/hub/shortages/' + currentLang, {responseType: 'text'});
    }

    fetchPracticeResources(lang: string): Observable<PracticeResourceResponse[]> {
        return this.httpClient
          .get<any>(`${environment.COMMONS_API_ENDPOINT}/hub/practiceresources/` + lang)
          .pipe(
            map(response => Array.isArray(response) ? response : [response])
          );
    }

    fetchContinuingEducation(lang: string): Observable<ContinuingEducationResponse[]> {
        return this.httpClient .get<ContinuingEducationResponse | ContinuingEducationResponse[]>(
            `${environment.COMMONS_API_ENDPOINT}/hub/continuingEducation/` + lang)
            .pipe(
                map(response => {
                    if (Array.isArray(response)) {
                        return response;
                    }
                    if (response && response.HubElements) {
                        return [response];
                    }
                    return [];
            })
        );
    }

    fetchEvents(lang: string): Observable<EventsResponse[]> {
        return this.httpClient .get<EventsResponse | EventsResponse[]>(
            `${environment.COMMONS_API_ENDPOINT}/hub/events/` + lang)
            .pipe(
                map(response => {
                    if (Array.isArray(response)) {
                        return response;
                    }
                    if (response && response.HubElements) {
                        return [response];
                    }
                    return [];
            })
        );
    }

    public static getCookie(name?: string): string {

        const nameEQ = name + "=";
        const ca = document.cookie.split(';');

        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    }
}